/**
 * Consumer hooks for the auth context.
 *
 *   - {@link useAuth}    — full context: status, actions, token accessor.
 *   - {@link useSession} — just the current session (or `null`).
 */
import { useContext } from 'react';
import { AuthContext } from './context.js';
/**
 * Access the auth context. Must be used within an {@link AuthProvider}.
 * @throws if no provider is mounted above.
 */
export function useAuth() {
    const ctx = useContext(AuthContext);
    if (ctx === null) {
        throw new Error('useAuth must be used within an <AuthProvider>.');
    }
    return ctx;
}
/** Convenience hook returning only the current {@link AuthSession} (or `null`). */
export function useSession() {
    return useAuth().session;
}
//# sourceMappingURL=hooks.js.map